<div class="field-radio-group">
  <div class="flex gap-3">
    <div class="field-checkbox-item">
      <p-checkbox
        [binary]="true"
        [ngModel]="isYesSelected()"
        (ngModelChange)="onYesChange($event)"
        [disabled]="disabled"
        [inputId]="getYesInputId()"
      ></p-checkbox>
      <label [for]="getYesInputId()">Yes</label>
    </div>
    <div class="field-checkbox-item">
      <p-checkbox
        [binary]="true"
        [ngModel]="isNoSelected()"
        (ngModelChange)="onNoChange($event)"
        [disabled]="disabled"
        [inputId]="getNoInputId()"
      ></p-checkbox>
      <label [for]="getNoInputId()">No</label>
    </div>
  </div>
</div>
